<template>
    <div class="create_company_store">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <!-- <li class="breadcrumb-item"><a href="#">Cart</a></li> -->
                        <li class="breadcrumb-item active" aria-current="page">
                            Create Company Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="accordian_with_form create_company_store_next">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Create Company Store</span
                                >
                            </h1>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div
                            class="accordion creat_company_store_accordion"
                            id="accordionExample"
                        >
                            <div class="card">
                                <div class="card-header p-0" id="headingOne">
                                    <h2
                                        class="mb-0 accordian_heading text-left d-flex"
                                        data-toggle="collapse"
                                        data-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        Store Information
                                        <span class="ml-auto my-auto minus"
                                            ><img
                                                src="maincss/images/minus.svg"
                                                alt=" "
                                        /></span>
                                        <span class="ml-auto my-auto plus"
                                            ><img
                                                src="maincss/images/plus.svg"
                                                alt=" "
                                        /></span>
                                    </h2>
                                </div>
                                <div
                                    id="collapseOne"
                                    class="collapse show"
                                    aria-labelledby="headingOne"
                                    data-parent="#accordionExample"
                                >
                                    <div
                                        class="card-body creat_company_store_info_body"
                                    >
                                        <div class="row">
                                            <div class="col-md-6 col-xl-4">
                                                <div class="form-group">
                                                    <input
                                                        type="text"
                                                        id="Email"
                                                        required="required"
                                                        placeholder="Enter here"
                                                        class="form-control bg-transparent"
                                                    />
                                                    <label>Store Name</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-xl-4">
                                                <div class="form-group">
                                                    <input
                                                        type="text"
                                                        id="Email"
                                                        required="required"
                                                        placeholder="Name"
                                                        class="form-control bg-transparent"
                                                    />
                                                    <label
                                                        >Add Additional Admin
                                                        (Optional)</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt_50">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <input
                                                        type="text"
                                                        id="Email"
                                                        required="required"
                                                        placeholder="Enter here"
                                                        class="form-control bg-transparent"
                                                    />
                                                    <label>Email ID</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <input
                                                        type="text"
                                                        id="Email"
                                                        required="required"
                                                        placeholder="Enter Password"
                                                        class="form-control bg-transparent"
                                                    />
                                                    <label>Password</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div
                                                    class="form-group enter_c_pwd"
                                                >
                                                    <input
                                                        type="text"
                                                        id="Email"
                                                        required="required"
                                                        placeholder="Enter Confirm Password"
                                                        class="form-control bg-transparent"
                                                    />
                                                    <label
                                                        >Confirm Password</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt_60">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label>Business Type</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                    <select
                                                        class="form-control bg-transparent"
                                                    >
                                                        <option>Select</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label
                                                        >Determine Store
                                                        Type</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                    <select
                                                        class="form-control bg-transparent"
                                                    >
                                                        <option>Select</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt_40">
                                            <div class="col-md-6">
                                                <div class="form-check pl-0">
                                                    <label
                                                        class="checkbox_custom filter_pro_label"
                                                        >Filter Product By Color
                                                        <input
                                                            type="checkbox"
                                                            checked="checked" /><span
                                                            class="checkmark"
                                                        ></span
                                                    ></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mt_26">
                                <div class="card-header p-0" id="headingTwo">
                                    <h2
                                        class="mb-0 accordian_heading text-left d-flex"
                                        data-toggle="collapse"
                                        data-target="#collapseTwo"
                                        aria-expanded="true"
                                        aria-controls="collapseTwo"
                                    >
                                        Select Items & Mark Ups

                                        <span class="ml-auto my-auto minus"
                                            ><img
                                                src="maincss/images/minus.svg"
                                                alt=" "
                                        /></span>
                                        <span class="ml-auto my-auto plus"
                                            ><img
                                                src="maincss/images/plus.svg"
                                                alt=" "
                                        /></span>
                                    </h2>
                                </div>
                                <div
                                    id="collapseTwo"
                                    class="collapse show"
                                    aria-labelledby="headingTwo"
                                    data-parent="#accordionExample"
                                >
                                    <div
                                        class="card-body creat_company_store_select_items_body"
                                    >
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label class="lf-4"
                                                        >Items</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                    <select
                                                        class="form-control bg-transparent"
                                                    >
                                                        <option>
                                                            Select Items
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div
                                                    class="form-group price-lf"
                                                >
                                                    <input
                                                        type="text"
                                                        id="Email"
                                                        required="required"
                                                        placeholder="$0.00"
                                                        class="form-control bg-transparent"
                                                    />
                                                    <label>Price($)</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                            <div class="col-md-4 d-flex">
                                                <a
                                                    href="#"
                                                    class="font_size_14 text_primary_blue btn_link mt-auto pb_2 company-store_addmore"
                                                    >+ Add More</a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mt_40">
                                <div class="card-header p-0" id="headingThree">
                                    <h2
                                        class="mb-0 accordian_heading text-left d-flex"
                                        data-toggle="collapse"
                                        data-target="#collapseThree"
                                        aria-expanded="true"
                                        aria-controls="collapseThree"
                                    >
                                        Add Logos

                                        <span class="ml-auto my-auto minus"
                                            ><img
                                                src="maincss/images/minus.svg"
                                                alt=" "
                                        /></span>
                                        <span class="ml-auto my-auto plus"
                                            ><img
                                                src="maincss/images/plus.svg"
                                                alt=" "
                                        /></span>
                                    </h2>
                                </div>
                                <div
                                    id="collapseThree"
                                    class="collapse show"
                                    aria-labelledby="headingThree"
                                    data-parent="#accordionExample"
                                >
                                    <div
                                        class="card-body creat_company_store_add_logo_body"
                                    >
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div
                                                    class="form-check pl-0 creat_company_form_check_box"
                                                >
                                                    <label
                                                        class="checkbox_custom brand_logo_select brand_logo_1366"
                                                    >
                                                        <img
                                                            src="maincss/images/create_brand_logo.png"
                                                            alt=""
                                                        />
                                                        <input
                                                            type="checkbox"
                                                            checked="checked"
                                                        /><span
                                                            class="checkmark"
                                                        ></span>
                                                        <div
                                                            class="delete_brand"
                                                        >
                                                            <a href="#"
                                                                ><img
                                                                    src="maincss/images/delete_brand.svg"
                                                                    alt=" "
                                                            /></a>
                                                        </div>
                                                    </label>

                                                    <div
                                                        class="brand_logo_select d-flex flex-column position-relative"
                                                    >
                                                        <input
                                                            type="file"
                                                            class="brand_logo_upload"
                                                        />
                                                        <img
                                                            src="maincss/images/add_more_brand.svg"
                                                            alt=" "
                                                        />
                                                        <p
                                                            class="font_size_20 text_primary_blue mt_10 mb-0"
                                                            style="
                                                                line-height: normal;
                                                            "
                                                        >
                                                            Add More
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card mt_40">
                                <div class="card-header p-0" id="headingFour">
                                    <h2
                                        class="mb-0 accordian_heading text-left d-flex set_date_heading_company"
                                        data-toggle="collapse"
                                        data-target="#collapseFour"
                                        aria-expanded="true"
                                        aria-controls="collapseFour"
                                    >
                                        Set Date

                                        <span class="ml-auto my-auto minus"
                                            ><img
                                                src="maincss/images/minus.svg"
                                                alt=" "
                                        /></span>
                                        <span class="ml-auto my-auto plus"
                                            ><img
                                                src="maincss/images/plus.svg"
                                                alt=" "
                                        /></span>
                                    </h2>
                                </div>
                                <div
                                    id="collapseFour"
                                    class="collapse show"
                                    aria-labelledby="headingFour"
                                    data-parent="#accordionExample"
                                >
                                    <div
                                        class="card-body creat_company_store_set_date_body"
                                    >
                                        <div class="row">
                                            <div class="col-md-12">
                                                <p class="m-0 d-inline-block">
                                                    <input
                                                        type="radio"
                                                        id="test1"
                                                        name="radio-group"
                                                        checked="checked"
                                                    />
                                                    <label
                                                        for="test1"
                                                        class="m-0 opacity_60"
                                                        >Default
                                                    </label>
                                                </p>
                                                <p
                                                    class="m-0 d-inline-block pl_20"
                                                >
                                                    <input
                                                        type="radio"
                                                        id="test2"
                                                        name="radio-group"
                                                    />
                                                    <label
                                                        for="test2"
                                                        class="m-0 opacity_60"
                                                        >Batch Dates</label
                                                    >
                                                </p>
                                            </div>
                                        </div>
                                        <div class="row mt_48">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <input
                                                        type="text"
                                                        class="form-control docs-date bg-transparent"
                                                        name="date"
                                                        placeholder="Select Date"
                                                        autocomplete="off"
                                                        id="datepicker"
                                                    />
                                                    <label>Launch Date</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                    <div
                                                        class="alert-icon pb_6"
                                                    >
                                                        <img
                                                            src="maincss/images/datepicker.svg"
                                                            alt=" "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <input
                                                        type="text"
                                                        class="form-control docs-date bg-transparent"
                                                        name="date"
                                                        placeholder="Select Date"
                                                        autocomplete="off"
                                                        id="datepicker2"
                                                    />
                                                    <label>Close Date</label
                                                    ><span
                                                        class="highlight"
                                                    ></span>
                                                    <div
                                                        class="alert-icon pb_6"
                                                    >
                                                        <img
                                                            src="maincss/images/datepicker.svg"
                                                            alt=" "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="creat_comany_btn">
                            <a
                                href="/created-company-store"
                                class="btn btn_orange bg_primary_orange text_white py_16 px_42 mt_60"
                                >Create Company Store</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "CreateCompanyStore",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        document.body.classList.add("footer_spacing_mange");
        /* eslint-disable */
        $(function () {
            $("#datepicker").datepicker();
            $("#datepicker2").datepicker();
        });
        /* eslint-enable */
    }
};
</script>
<style>
.ui-widget.ui-widget-content {
    border: unset !important;
    height: auto !important;
}
</style>
